export default __webpack_public_path__ + "static/media/measure-dsk.c644c9a6.png";